import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material"
import { EditOutlined, MoreVertOutlined } from "@mui-symbols-material/w300"
import React, { useState } from "react"

import { CompanyStatus } from "@/graphql/codegen/graphql"
import { usePaymentTermsContext } from "@/screens/CompanySettings/Accounting/contexts/PaymentTermsContext"
import { withClose } from "@/utils/withClose"

interface PaymentTermsActionsProps {
  onEdit: () => void
}

const PaymentTermsActions: React.FC<PaymentTermsActionsProps> = ({ onEdit }) => {
  const { companyStatus } = usePaymentTermsContext()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const isCompanyPendingStatus = companyStatus === CompanyStatus.Pending

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  if (isCompanyPendingStatus) {
    return (
      <IconButton color='primary' onClick={onEdit} className='size-5 p-0' aria-label='Edit payment terms'>
        <EditOutlined className='size-5 text-primary' />
      </IconButton>
    )
  }

  return (
    <>
      <IconButton color='primary' onClick={handleMenuClick} className='size-5 p-0' aria-label='payment terms actions'>
        <MoreVertOutlined className='size-5 text-primary' />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={withClose(handleClose)(onEdit)}>
          <ListItemIcon>
            <EditOutlined className='size-5 text-primary' />
          </ListItemIcon>
          <ListItemText primary='Edit Payment Terms' />
        </MenuItem>
      </Menu>
    </>
  )
}

export default PaymentTermsActions
